<template>
  <div id="chat">
    <section class="chat_list">
      <div class="tabs">
        <div
          class="tab"
          :class="{ curTabs: curTabIndex === 0 }"
          @click="changeTab(0)"
        >
          当前对话
          <!-- <span class="no_read_nul" v-if="noReadNum !== 0">{{
            noReadNum > 99 ? "99+" : noReadNum
          }}</span> -->
        </div>
        <div
          class="tab"
          :class="{ curTabs: curTabIndex === 1 }"
          @click="changeTab(1)"
        >
          排队列表
        </div>
      </div>
      <div class="tab-line" :class="[curTabIndex == 0 ? 'tl-l' : 'tl-r']"></div>

      <!-- 当前对话 -->
      <div class="user-wrap" v-show="curTabIndex === 0">
        <virtual-list
          class="stream scroll-touch"
          :data-key="'i'"
          :data-sources="dangqianList"
          :data-component="itemComponent"
          @tobottom="onToBottom"
        >
          <div
            slot="footer"
            class="loading-footer"
            v-if="dangqianList.length > 10"
          >
            <div class="spinner" v-show="!finished">
              <!-- <i class="el-icon-loading"></i> -->
              <img src="@/assets/img/loading.gif" alt="" class="loading-img" />
            </div>
            <div class="finished" v-show="finished">没有更多数据了</div>
          </div>
        </virtual-list>
      </div>

      <!-- 排队列表 -->
      <div class="user-wrap" v-show="curTabIndex === 1">
        <ul>
          <template v-for="(item, index) in usersList">
            <li
              v-if="item.type === 1"
              :key="index"
              @click="changeChat(item)"
              :class="{ active_li: item.i === curLeftChat }"
            >
              <userItem
                :name="item.u_n"
                :msg="item.msg"
                :hasNews="+item.un_r_c"
                :curPkg="cur_pkg"
                :i="item.i"
              ></userItem>
            </li>
          </template>
        </ul>
      </div>
    </section>

    <section class="chating">
      <div class="chatbox">
        <!-- 聊天内容 -->
        <div class="chatbox-wrap" id="wrapper" ref="chatwrap">
          <template v-if="curLeftChat !== -1">
            <template v-for="it in usersList">
              <ul ref="wrap" :key="it.i" v-if="it.i === curLeftChat">
                <template v-if="it.content.length > 0">
                  <virtual-list
                    ref="vsl"
                    :keeps="50"
                    style="height: 100%"
                    class="stream scroll-touch"
                    :data-key="'ts'"
                    :data-sources="it.content"
                    :data-component="chatContentComponent"
                    @totop="onToTop"
                  >
                    <div
                      slot="header"
                      class="loading-footer"
                      v-show="overflowHeader"
                    >
                      <div class="spinner" v-show="!finishedHeader">
                        <img
                          src="@/assets/img/loading.gif"
                          alt=""
                          class="loading-img"
                        />
                        <!-- <i class="el-icon-loading"></i> -->
                      </div>
                      <div class="finished" v-show="finishedHeader">
                        已经到顶了
                      </div>
                    </div>
                  </virtual-list>
                </template>
                <template v-else>
                  <div class="loading">
                    <!-- <i class="el-icon-loading"></i> -->
                    <img
                      src="@/assets/img/loading.gif"
                      alt=""
                      class="loading-img"
                    />
                  </div>
                </template>
              </ul>
            </template>
            <!-- <div id="bottom_box" style="padding-bottom:80px;width:100%;background:red;"></div> -->
            <div
              v-if="fileSendTxt"
              style="
                position: absolute;
                left: 0;
                top: 0;
                text-align: center;
                line-height: 40px;
                width: 100%;
                font-size: 14px;
                color: #8d8d8d;
                padding-bottom: 20px;
              "
            >
              {{ fileSendTxt }}
            </div>
          </template>

          <template v-else>
            <div class="chat-empty">
              <img src="../../assets/img/huihua.png" alt="" />
            </div>
          </template>
        </div>

        <!-- 发送消息 -->
        <div class="chatbox-footer">
          <div class="msg-toolbar">
            <label class="file">
              <i class="el-icon-picture"></i>
              <input
                type="file"
                accept="image/*"
                @change="handleFileChange"
                ref="pic"
                class="file-input"
              />
            </label>

            <label class="file">
              <i class="el-icon-folder-opened"></i>
              <input
                type="file"
                @change="handleFileChange"
                ref="pic"
                class="file-input"
              />
            </label>
          </div>
          <div class="msg-input">
            <div class="input-box">
              <textarea
                v-model="textContent"
                cols="30"
                rows="10"
                placeholder="在此输入聊天内容"
                @keydown="handKeyCode($event)"
              ></textarea>
            </div>
          </div>
        </div>
        <div
          class="chatbox-send"
          :class="{ enable: textContent == '' || sending }"
          @click="sendChat"
        >
          发送
        </div>
      </div>
    </section>

    <section class="chat_info">
      <div class="ci-title">访客信息</div>
      <template v-if="curLeftChat !== -1">
        <div class="ci-content">
          <template v-for="(item, index) in usersList">
            <ul :key="index" v-if="item.i === curLeftChat">
              <uInfo :info="item.userObj"></uInfo>
            </ul>
          </template>
        </div>
        <!-- 标签管理 -->
        <div class="ci-problem">
          <p>标签管理<span>(通过标签给用户分类)</span></p>
          <template v-for="(item, index) in usersList">
            <div :key="index" v-show="item.i === curLeftChat">
              <tag
                :tagVisib="tags.visib"
                :curId="curUserId"
                :curPkg="cur_pkg"
                :curTagsList="item.userObj ? item.userObj.tags : []"
              ></tag>
            </div>
          </template>
        </div>

        <!-- 订单管理 -->
        <div class="ci-problem">
          <p>订单管理<span>(获取详细订单信息)</span></p>
          <div>
            <el-button type="success" round @click="openOrderInfo"
              >订单详情
              <i class="el-icon-notebook-2"></i>
            </el-button>
          </div>
        </div>

        <!-- 会员操作 -->
        <div class="ci-problem">
          <p>会员操作<span>(赠送或减少时间)</span></p>
          <div>
            <el-button type="success" round @click="timeVisib = true"
              >时间操作
              <i class="el-icon-date"></i>
            </el-button>
          </div>
        </div>

        <!-- 分组 -->
        <group
          :curUserId="curUserId"
          :curUserName="curUserNm"
          :curPkg="cur_pkg"
        ></group>

        <!-- 问题归档 -->
        <div class="ci-problem">
          <p>问题归档<span>(将问题记录反馈，关闭当前会话)</span></p>
          <div>
            <el-button type="primary" round @click="problem.visib = true"
              >归档
              <i class="el-icon-folder-opened"></i>
            </el-button>

            <el-button type="warning" round @click="quickSure"
              >快速归档
              <i class="el-icon-folder-opened"></i>
            </el-button>
          </div>
        </div>

        <!-- 快速回复 -->
        <chatReply @getTreeValue="getTreeValue"></chatReply>
      </template>

      <!-- 未选中用户时，显示empty -->
      <template v-else>
        <div class="chat-empty">
          <img src="../../assets/img/null.png" alt="" />
        </div>
      </template>
    </section>

    <!-- 问题归档弹框 -->
    <el-dialog title="问题归档" :visible.sync="problem.visib" width="40%">
      <el-row type="flex" align="middle">
        <el-col :span="4">
          <span>问题：</span>
        </el-col>
        <el-col :span="20">
          <el-select
            v-model="problem.select"
            placeholder="请选择问题类型"
            style="width: 100%"
          >
            <el-option
              v-for="item in problemOption"
              :key="item.pk"
              :label="item.name"
              :value="item.pk"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex" style="margin-top: 20px" align="middle">
        <el-col :span="4">
          <span>描述：</span>
        </el-col>
        <el-col :span="20">
          <el-input
            placeholder="请输入详细描述"
            v-model="problem.desc"
            autocomplete="off"
          ></el-input>
        </el-col>
      </el-row>
      <el-row type="flex" style="margin-top: 20px" align="middle">
        <el-col :span="4">
          <span>是否解决：</span>
        </el-col>
        <el-col :span="20">
          <el-select v-model="problem.is_solve" placeholder="请选择">
            <el-option
              v-for="item in optionsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="problem.visib = false">取 消</el-button>
        <el-button type="primary" @click="problemSure">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 会员操作弹框 -->
    <el-dialog title="时间操作" :visible.sync="timeVisib" width="40%">
      <el-row type="flex" align="middle">
        <el-col :span="4">
          <span>操作类型：</span>
        </el-col>
        <el-col :span="20">
          <el-select
            v-model="timeType"
            placeholder="请选择操作类型"
            style="width: 100%"
          >
            <el-option
              v-for="item in timeOption"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex" style="margin-top: 20px" align="middle">
        <el-col :span="4">
          <span>操作天数：</span>
        </el-col>
        <el-col :span="20">
          <el-input
            placeholder="请输入天数(整数)"
            v-model="timeDay"
            autocomplete="off"
            type="number"
          ></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="timeVisib = false">取 消</el-button>
        <el-button type="primary" @click="timeHandle">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 订单详情弹框 -->
    <el-drawer
      title="订单详情"
      direction="ltr"
      :visible.sync="orderVisib"
      :with-header="false"
      size="75%"
    >
      <order :tdata="orderData"></order>
    </el-drawer>
  </div>
</template>

<script>
import chatItem from "../../components/ChatItem";
import userItem from "../../components/ChatUserItem";
import chatReply from "../../components/ChatReply";
import Item from "./item";
import uInfo from "./userInfo";
import Tag from "./tags";
import order from "./order";
import group from "./group";
import VirtualList from "vue-virtual-scroll-list";
import cItem from "./chatContent";
import Cookies from "js-cookie";

import { mapGetters } from "vuex";
import { fileType, chatContentFileType } from "../../utils/index";
import {
  chatList,
  queueList,
  getChatMsg,
  getUserDetail,
  sendMsg,
  closeMsg,
  updateFile,
  tagsList,
  updateTag,
  getHistoryList,
  timeOpp,
  getOrderInfo,
} from "../../api/chat";

export default {
  name: "chat",
  components: {
    chatItem,
    userItem,
    chatReply,
    uInfo,
    Tag,
    "virtual-list": VirtualList,
    cItem,
    order,
    group,
  },

  computed: {
    ...mapGetters(["name", "cur_pkg"]),
    changeUser() {
      return this.$store.state.app.curUser;
    },
    hasUserInfo() {
      if (Object.keys(this.userInfo).length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    all_list() {
      return JSON.parse(localStorage.getItem("msg"));
    },
    dangqianList() {
      if (this.usersList && this.usersList.length > 0) {
        return this.usersList
          .filter((item) => {
            return item.type === 0;
          })
          .splice(0, this.pageSize * this.page);
      } else {
        return [];
      }
    },
  },

  watch: {
    // 监听包名变化
    cur_pkg(val, nVal) {
      // 包变化，初始化列表，remove列表，重置第一次请求
      this.curLeftChat = -1;
      this.getNum = 0;
      this.usersList = [];
      localStorage.removeItem("usersList");

      this.$store.dispatch("app/changeUser", -1);
      localStorage.setItem("curUser", -1);
    },
    // 左右切换 清除定时器 加载数据
    curTabIndex(val) {
      if (val === 0) {
        clearInterval(this.leftInterver);
        clearInterval(this.rightInterver);
        this.initLeftChat();
      } else {
        clearInterval(this.leftInterver);
        clearInterval(this.rightInterver);
        this.initRightChat();
      }
    },
    "$store.state.app.curUser": function (val) {
      if (val == 0) return;
      let cur = this.usersList.filter((item) => {
        return item.i === val;
      })[0];
      this.curUserId = val;
      this.curUserNm = cur?.u_n;
      if (cur) {
        this.changeChat(cur);
      }
    },
  },

  data() {
    return {
      sending: false,
      curUserNm: "",
      timeType: null,
      timeDay: null,
      timeOption: [
        { key: 1, value: "添加" },
        { key: 2, value: "减少" },
      ],
      timeVisib: false,
      orderVisib: false,
      noReadNum: 0,
      chatSource: [],
      itemComponent: Item,
      chatContentComponent: cItem,
      curLeftChat: -1,
      pkgName: "fast.speedvpn.unblock.wifisecurity.proxy",
      fileSendTxt: "",
      problemValue: true,
      tags: {
        visib: false,
        setVisib: false,
        value: [],
      },
      problem: {
        visib: false,
        value: "",
        desc: "",
        solve: false,
        select: "",
        is_solve: "",
      },
      inputVisible: false,
      inputValue: "",
      problemOption: [],
      optionsType: [
        {
          value: 0,
          label: "已解决",
        },
        {
          value: 1,
          label: "不解决",
        },
        {
          value: 2,
          label: "未解决-用户离线",
        },
        {
          value: 3,
          label: "未解决-无辅助信息",
        },
        {
          value: 4,
          label: "转给开发",
        },
      ],

      textContent: "",
      curTabIndex: 0,
      leftList: [],
      rightList: [],
      curChatId: -1,
      curUser: {},
      userInfo: {},

      leftInterver: null,
      rightInterver: null,
      timeWrap: 5000,

      scrollLoading: false,
      scrollNoMore: false,

      usersList: [],
      chatContentList: [],
      getNum: 0,
      ids_list: [],
      page: 1,
      pageSize: 12,
      finished: false,
      finishedHeader: false,
      overflowHeader: false,
      curUserId: 0,
      orderData: [],
    };
  },

  mounted() {
    // 获取初始化列表顺序
    this.curTabIndex = +Cookies.get("tabIndex");
    let _curIndex = this.curTabIndex;

    // 初始化列表
    if (_curIndex === 0) {
      this.initLeftChat();
    } else {
      this.initRightChat();
    }

    this.getTagsList();
    this.usersList = JSON.parse(localStorage.getItem("usersList"));
  },

  beforeDestroy() {
    // 清除定时器
    clearInterval(this.leftInterver);
    clearInterval(this.rightInterver);

    // 初始化不选中用户
    this.$store.dispatch("app/changeUser", 0);
    localStorage.setItem("curUser", 0);
  },

  methods: {
    // 获取订单详情
    openOrderInfo() {
      this.orderData = [];
      this.orderVisib = true;

      let _dev = "";
      this.usersList.forEach((item) => {
        if (item.i == this.curLeftChat) {
          _dev = item.userObj.d;
        }
      });

      getOrderInfo({
        dev: _dev,
        p: this.cur_pkg,
      })
        .then((res) => {
          this.orderData = res;
        })
        .catch((err) => {
          // this.$message({
          //   message: "获取列表失败，请重试",
          //   type: "warning",
          // });
        });
    },

    // 获取标签列表
    getTagsList() {
      tagsList().then((res) => {
        this.problemOption = res.issue;
        localStorage.setItem("tag", JSON.stringify(res));
      });
    },

    // 聊天内容上滑
    onToTop() {
      this.overflowHeader = true;
      this.finishedHeader = false;

      let _cur = this.usersList.filter((item) => {
        return item.i === this.curLeftChat;
      })[0];
      let _curCopy = _cur.content;
      let params = {
        ts: _cur.content[0].ts,
        i: this.curLeftChat,
      };

      getHistoryList(params).then((res) => {
        if (res.length > 0) {
          res.forEach((it) => {
            it = fileType(it.msg, +this.curUser.i, it.ts, this.cur_pkg, it);
          });
          _cur.content = res.concat(_curCopy);
        }
        this.overflowHeader = false;
      });
    },

    // 当前对话滑动底部
    onToBottom() {
      let allLength = this.usersList.filter((item) => {
        return item.type === 0;
      }).length;
      if (this.pageSize * this.page < allLength) {
        setTimeout(() => {
          this.page++;
        }, 1000);
        this.finished = false;
      } else {
        this.finished = true;
      }
    },

    changeTab(ind) {
      this.curTabIndex = ind;
      Cookies.set("tabIndex", ind);
    },

    // 键盘处理
    handKeyCode(e) {
      if (e.keyCode == 13) {
        if (!e.metaKey) {
          e.preventDefault();
          // 回车
          this.sendChat();
        } else {
          this.textContent = this.textContent + "\n";
        }
      }
    },

    // 消息置底
    msgToBottom() {
      this.$nextTick(() => {
        if (this.$refs.vsl) {
          this.$refs.vsl[0].scrollToBottom();
        }
      });
    },

    // 发送图片 文件
    handleFileChange(e) {
      let fileSize = e.target.files[0].size;
      var size = fileSize / 1024;
      if (size > 1024) {
        this.$message({
          message: "文件不能大于1M",
          type: "warning",
        });
        return false;
      }

      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      formData.append("i", this.curUser.i);
      formData.append("p", this.cur_pkg);
      formData.append("m", this.curUser.u_n);

      this.fileSendTxt = "文件发送中...";
      let _that = this;
      updateFile(formData)
        .then((res) => {
          this.fileSendTxt = "文件发送成功";

          // 模拟消息格式
          let msg = chatContentFileType(file.name);
          let obj = {
            is_b: true,
            msg,
            ts: res.t,
          };
          obj = fileType(msg, +this.curUser.i, res.t, this.cur_pkg, obj);
          // 手动push进
          this.usersList.forEach((item) => {
            if (item.i === this.curUser.i) {
              item.content.push(obj);
            }
          });

          // this.getChatHistory();
          this.msgToBottom();

          if (this.curTabIndex === 1) {
            this.getLeftData();
            this.curTabIndex = 0;

            this.usersList.forEach((uVal, index) => {
              if (uVal.i === this.curUser.i) {
                // 换位置
                let temp;
                temp = this.usersList[0];
                this.usersList[0] = this.usersList[index];
                this.usersList[index] = temp;
              }
            });
          }

          setTimeout(() => {
            _that.fileSendTxt = "";
          }, 2000);
        })
        .catch((err) => {
          this.fileSendTxt = "文件发送失败,请重试";
          setTimeout(() => {
            _that.fileSendTxt = "";
          }, 2000);
        });
    },

    // 轮询请求当前对话列表
    initLeftChat() {
      this.leftInterver = window.setInterval(() => {
        setTimeout(() => {
          this.getLeftData();
        }, 1);
      }, this.timeWrap);
    },

    // 轮询请求排队列表
    initRightChat() {
      this.rightInterver = window.setInterval(() => {
        setTimeout(() => {
          this.getRightData();
        }, 1);
      }, this.timeWrap);
    },

    // 对象 -> 数组
    objToArray(obj, type = 0) {
      let _list = [];
      for (let i in obj) {
        obj[i].content = [];
        obj[i].type = type;
        _list.push(obj[i]);
      }
      return _list;
    },

    // 当前对话列表
    getLeftData() {
      let params = {
        p: this.cur_pkg,
      };
      if (this.ids_list.length > 0) {
        let _copyIds = Object.assign([], this.ids_list);
        let _arr = _copyIds.splice(0, this.page * this.pageSize).join(",");
        // params.ids = _copyIds.splice(0, this.page * this.pageSize).join(",");

        if (
          _arr.indexOf(this.curUser.i) === -1 &&
          this.curUser.i !== undefined
        ) {
          params.ids = _arr + "," + this.curUser.i;
        }else{
          params.ids = _arr 
        }

      }

      chatList(params).then((res) => {
        let closeIds = res.clo_id;
        let result = this.objToArray(res.info);
        let _copy = this.usersList || [];

        result.forEach((resVal, rdex) => {
          let flag = false;
          _copy.map((_cVal, index) => {
            if (_cVal.i === resVal.i) {
              _cVal.msg = resVal.msg;
              _cVal.ts = resVal.ts;
              _cVal.type = resVal.type;
              _cVal.u_n = resVal.u_n;
              // 正处于当前id， 未读消息为0
              if (_cVal.i == this.curUserId) {
                _cVal.un_r_c = 0;
              } else {
                _cVal.un_r_c = +resVal.un_r_c;
              }

              _cVal.content = _cVal.content;
              flag = true;
            }
          });

          if (flag == false) {
            _copy.push(resVal);
          }

          // 处于当前对话，并且有未读消息，主动请求记录
          if (this.curUser) {
            if (this.curUser.i === resVal.i && resVal.un_r_c !== 0) {
              this.getChatHistory();
            }
          }
        });

        let nList = [];
        _copy.forEach((item) => {
          if (item.un_r_c !== undefined) {
            nList.push(item.un_r_c);
          }
        });

        var _noReadNum = nList.reduce((pre, next) => {
          return pre + next;
        }, 0);
        this.noReadNum = _noReadNum;

        if (closeIds && closeIds.length > 0) {
          closeIds.forEach((close_Val) => {
            _copy.forEach((_cVal, index) => {
              if (_cVal.i === close_Val) {
                _copy.splice(index, 1);
              }
            });
          });
        }

        // 第一次记录 ids
        if (this.getNum === 0) {
          let ids = [];
          result.forEach((item) => {
            ids.push(item.i);
          });
          this.ids_list = ids;
        }

        let readList = _copy.filter((item) => {
          return item.un_r_c !== 0;
        });
        let noReadList = _copy.filter((item) => {
          return item.un_r_c === 0;
        });

        this.usersList = readList.concat(noReadList);

        localStorage.setItem("usersList", JSON.stringify(_copy));
        this.getNum++;
      });
    },

    // 排队列表
    getRightData() {
      let params = {
        p: this.cur_pkg,
      };

      queueList(params).then((res) => {
        let result = this.objToArray(res, 1);
        let _copy = this.usersList || [];

        result.forEach((resVal) => {
          let flag = false;
          _copy.map((_cVal, index) => {
            if (_cVal.i === resVal.i) {
              _cVal.msg = resVal.msg;
              _cVal.ts = resVal.ts;
              _cVal.type = resVal.type;
              _cVal.u_n = resVal.u_n;
              _cVal.un_r_c = resVal.un_r_c;

              _cVal.content = _cVal.content;
              flag = true;
            }
          });
          if (flag == false) {
            _copy.push(resVal);
          }

          // 处于当前对话，并且有未读消息，主动请求记录
          if (this.curUser.i === resVal.i && resVal.un_r_c !== 0) {
            // this.getChatHistory();
            this.getPaiduiHistory();
          }
        });

        this.usersList = _copy;
        // 不能同时存，每次只请求一个可以存
        localStorage.setItem("usersList", JSON.stringify(_copy));
      });
    },

    // 获取用户信息
    getUserInfo() {
      let params = {
        i: this.curUserId,
        p: this.cur_pkg,
      };
      this.usersList.forEach((cur) => {
        if (cur.i === this.curUserId) {
          getUserDetail(params).then((res) => {
            cur.userObj = res;
          });
        }
      });
    },

    // 对话列表点击 开始聊天
    changeChat(item) {
      this.curUser = item;
      this.curLeftChat = item.i;
      this.textContent = "";

      let params = {
        // ts: item.ts,
        i: +item.i,
        p: this.cur_pkg,
      };

      getChatMsg(params).then((res) => {
        // 处理消息格式
        res.forEach((it) => {
          it = fileType(it.msg, +this.curUser.i, it.ts, this.cur_pkg, it);
        });

        this.usersList.forEach((uVal) => {
          if (uVal.i === item.i) {
            uVal.un_r_c = 0; //未读消息为0
            uVal.content = res;
            this.chatSource = uVal.content;
          }
        });

        this.usersList.forEach((cur) => {
          if (cur.i === item.i) {
            if (cur.userObj) {
              this.userInfo = cur.userObj;
            } else {
              getUserDetail(params).then((res) => {
                cur.userObj = res;
                this.userInfo = res;
              });
            }
          }
        });

        // 聊天内容滚动到底部
        this.$nextTick(() => {
          if (this.$refs.vsl[0]) {
            this.$refs.vsl[0].scrollToBottom();
          }
        });
      });
    },

    afterUploadGerHistory(t, name) {
      this.usersList.forEach((item, index) => {
        if (item.i === this.curUser.i) {
          item.content.push({
            ts: t,
            msg: name,
            is_b: true,
            type: "word",
            url: "",
          });
        }
      });
    },

    getPaiduiHistory() {
      let _params = {
        i: this.curUser.i,
        p: this.cur_pkg,
      };

      getChatMsg(_params).then((res) => {
        if (res) {
          res.forEach((it) => {
            it = fileType(it.msg, +this.curUser.i, it.ts, this.cur_pkg, it);
          });

          this.usersList.forEach((uVal) => {
            if (uVal.i === this.curUser.i) {
              uVal.content = res;
            }
          });
        }

        this.$nextTick(() => {
          if (this.$refs.vsl[0]) {
            this.$refs.vsl[0].scrollToBottom();
          }
        });
      });
    },

    // 获取聊天记录
    getChatHistory() {
      // TODO： 第一次进来 还是 以后进来 t
      let _params = {
        i: this.curUser.i,
        p: this.cur_pkg,
      };

      let ts;
      // 获取当前用户
      let _cur = this.usersList.filter((item) => {
        return item.i == this.curLeftChat;
      })[0];

      // 获取客服回复最后一条消息时间
      if (_cur.content.length > 0) {
        for (let i = _cur.content.length; i--; i > 0) {
          if (_cur.content[i].is_b) {
            ts = _cur.content[i].ts;
            break;
          }
        }
        _params.ts = ts;
      }

      getChatMsg(_params).then((res) => {
        if (res) {
          res.forEach((it) => {
            it = fileType(it.msg, +this.curUser.i, it.ts, this.cur_pkg, it);
          });
          this.usersList.forEach((uVal) => {
            if (uVal.i === this.curUser.i) {
              uVal.content = uVal.content.concat(res);
            }
          });
        }

        this.$nextTick(() => {
          if (this.$refs.vsl[0]) {
            this.$refs.vsl[0].scrollToBottom();
          }
        });
      });
    },

    // 发送信息
    sendChat() {
      // 未选中用户
      if (!this.curUser.i) {
        this.$message({
          message: "当前未选择联系人，不能发送消息",
          type: "warning",
        });
        return false;
      }
      // 消息不为空
      if (this.textContent === "") return;

      this.sending = true;
      let params = {
        p: this.cur_pkg,
        i: this.curUser.i,
        m: this.curUser.u_n,
        g: this.textContent,
      };

      sendMsg(params).then((res) => {
        // 手动push最后一条，类型为 word 类型
        this.usersList.forEach((item, index) => {
          if (item.i === this.curUser.i) {
            item.content.push({
              ts: res.t,
              msg: this.textContent,
              is_b: true,
              type: "word",
              url: "",
            });
            this.$nextTick(() => {
              if (this.$refs.vsl) {
                this.$refs.vsl[0].scrollToBottom();
              }
            });
            this.sending = false;
          }
        });

        // 清空发送消息栏
        this.textContent = "";
        // 当前对话列表，主动更新最新消息
        this.getLeftData();

        if (this.curTabIndex === 1) {
          // 发送消息时，处于排队列表，将状态改变为当前对话
          this.usersList.forEach((it) => {
            if (it.i === this.curUser.i) {
              it.type = 0;
            }
          });

          this.ids_list = [];
          this.getNum = 0;
          this.getLeftData();

          // 切换当前选中用户，当前对话列表和排队列表使用不是同一种选中方式，
          this.$store.dispatch("app/changeUser", this.curUser.i, "这里切换");
          localStorage.setItem("curUser", this.curUser.i);

          // 排队列表里回复消息，该消息状态变为当前对话，放入当前对话第一条位置
          this.usersList.forEach((uVal, index) => {
            if (uVal.i === this.curUser.i) {
              let temp;
              temp = this.usersList[0];
              this.usersList[0] = this.usersList[index];
              this.usersList[index] = temp;
            }
          });
        }
      });
    },

    // 快速归档
    quickSure() {
      let params = {
        p: this.cur_pkg,
        i: +this.curUser.i,
        is_solve: 2,
        issue: "",
        desc: "",
      };

      closeMsg(params).then((res) => {
        this.problem.visib = false;
        this.$message({
          message: "归档成功",
          type: "success",
        });

        this.problem.select = "";
        this.problem.is_solve = "";
        this.problem.value = "";
        this.problem.desc = "";
        // 清空访客信息
        this.userInfo = {};
        // 重置未选中
        this.curLeftChat = -1;
        // 清空当前聊天内容
        this.usersList.forEach((item, index) => {
          if (item.i === this.curUser.i) {
            // 从local 移除
            this.usersList.splice(index, 1);
          }
        });
      });
    },

    // 归档
    problemSure() {
      if (this.curUser.type === 1) {
        this.problem.visib = false;
        this.$message({
          message: "未处理信息不能归档",
          type: "warning",
        });
        return false;
      }

      if (this.problem.is_solve === "") {
        this.$message({
          message: "请填写完整信息再归档",
          type: "warning",
        });
        return false;
      }

      let params = {
        p: this.cur_pkg,
        i: +this.curUser.i,
        is_solve: this.problem.is_solve,
        issue: this.problem.select,
        desc: this.problem.desc,
      };

      closeMsg(params).then((res) => {
        this.problem.visib = false;
        this.$message({
          message: "归档成功",
          type: "success",
        });

        this.problem.select = "";
        this.problem.is_solve = "";
        this.problem.value = "";
        this.problem.desc = "";
        this.curUser = {};
        // 清空访客信息
        this.userInfo = {};
        // 重置未选中
        this.curLeftChat = -1;
        // 清空当前聊天内容
        this.usersList.forEach((item, index) => {
          if (item.i === this.curUser.i) {
            // 从local 移除
            this.usersList.splice(index, 1);
          }
        });
      });
    },

    // 快捷回复
    getTreeValue(value) {
      this.textContent = this.textContent + value;
    },

    // 会员时间操作
    timeHandle() {
      if (!this.timeType) {
        this.$message({
          message: "请选择操作类型",
          type: "warning",
        });
        return;
      }
      if (!this.timeDay) {
        this.$message({
          message: "请填写操作天数",
          type: "warning",
        });
        return;
      }
      let params = {
        p: this.cur_pkg,
        u_id: this.curUserId,
        day: +this.timeDay,
        op: this.timeType,
      };

      timeOpp(params)
        .then((res) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.timeVisib = false;

          this.timeType = null;
          this.timeDay = null;
        })
        .catch((err) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
          this.timeVisib = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#chat {
  display: flex;
  width: 100%;
  height: calc(100vh - 50px);
}
.enable {
  cursor: not-allowed !important;
  background: #ccc !important;
}
.chat_list {
  width: 25%;
  height: 100%;
  border-right: 1px solid #ddd;
  background: #f3f3f4;
  position: relative;
  .tabs {
    display: flex;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #e6e6e6;
    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 50%;
      height: 100%;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      .no_read_nul {
        position: absolute;
        right: 0;
        top: 5px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        line-height: 18px;
        background: #d92f2f;
        text-align: center;
        color: #ffffff;
        font-size: 12px;
      }
    }
  }
  .tab-line {
    width: 50%;
    height: 2px;
    background: #5fb878;
    position: absolute;
    top: 38px;
    left: 0;
    transition: all 0.3s ease;
  }
  .tl-l {
    transform: translate3d(0, 0, 0);
  }
  .tl-r {
    transform: translate3d(100%, 0, 0);
  }
  .user-wrap {
    height: 100%;
    overflow-y: scroll;

    ul {
      margin-top: 0;
      padding-left: 0;
      padding-bottom: 40px;
      display: flex;
      flex-direction: column;
      li {
        height: 70px;
        list-style: none;
        cursor: pointer;
      }
      .curUser {
        background: #bac5d6 !important;
      }
    }
  }
}
.curTabs {
  color: #009688 !important;
  font-weight: 600 !important;
  position: relative;
}
.chating {
  width: 50%;
  height: 100%;
  border-right: 1px solid #ddd;
  background: #ffffff;
}
.chatbox {
  position: relative;
  width: 100%;
  height: 100%;
  &-wrap {
    width: 100%;
    height: 70%;
    overflow-y: scroll;
    border-bottom: 1px solid #eeeeee;
    ul {
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      margin: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      li {
        width: 100%;
        list-style: none;
      }
    }
  }
  &-footer {
    width: 100%;
    height: 100px;
    .msg-toolbar {
      width: 100%;
      height: 34px;
      padding-top: 6px;
      padding-left: 10px;
      i {
        color: #858684;
        // margin-left: 6px;
        margin-right: 6px;
        font-size: 24px;
      }
    }
    .msg-input {
      width: 100%;
      height: 150px;
      textarea {
        width: 100%;
        height: 150px;
        border: none;
        overflow-y: scroll;
        font-weight: normal;
        overflow-x: hidden;
        word-break: break-all;
        font-style: normal;
        outline: none;
        padding: 10px;
        resize: none;
        font-size: 14px;
        line-height: 21px;
        color: #606266;
      }
      .input-box {
        width: 100%;
        height: 150px;
        overflow-y: auto;
      }
    }
  }
  &-send {
    position: absolute;
    right: 20px;
    height: 46px;
    bottom: 10px;
    width: 100px;
    background: #409eff;
    border-radius: 4px;
    line-height: 46px;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
  }
}
.chat_info {
  width: 25%;
  height: 100%;
  overflow-y: scroll;
  background: #f3f3f4;
  .ci-title {
    height: 40px;
    width: 100%;
    text-align: center;
    line-height: 40px;
    color: #009688;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid #ddd;
  }
  .ci-content {
    ul {
      margin: 0;
      padding: 20px 20px 40px;
      li {
        margin-bottom: 10px;
        list-style: none;
        font-size: 14px;
        line-height: 21px;
        color: #333333;
      }
      li:last-child {
        margin-bottom: 0;
      }
    }
  }
  .ci-problem {
    padding: 0 20px 40px;
    p {
      margin: 0 0 15px;
      color: #333333;
      font-size: 16px;
    }
    span {
      margin-left: 10px;
      color: #8d8d8d;
      font-size: 12px;
    }
  }
}
.file {
  cursor: pointer;
}
.file-input {
  display: none;
}
.chat-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80%;
  img {
    width: 80px;
  }
}
.active_li {
  background: #bac5d6 !important;
}

.stream,
.empty {
  position: relative;
  width: 100%;
  height: 95%;
  border-bottom: none;
  overflow-y: auto;
  // display: flex;
  // flex-direction: column-reverse;
  @media (max-width: 640px) {
    height: 430px;
  }
  &.overflow {
    flex-direction: column;
  }
  .stream-item {
    display: flex;
    align-items: center;
    padding: 1em;
    @media (max-width: 640px) {
      padding: 0.5em;
    }
    &.creator {
      flex-direction: row-reverse;
    }
  }
}
.loading-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  .spinner {
  }
  .finished {
    font-size: 14px;
    color: #bfbfbf;
  }
}
.loading-img {
  width: 30px;
}
</style>
